export interface ExecutionPollingBindingsOwner {
  acquire: () => void
  release: () => void
  dispose: () => void
}

let installedBindings: ExecutionPollingBindingsOwner | null = null

export const installExecutionPollingBindings = (bindings: ExecutionPollingBindingsOwner): void => {
  installedBindings = bindings
}

export const getExecutionPollingBindings = (): ExecutionPollingBindingsOwner => {
  if (!installedBindings) throw new Error('crosschain_execution_polling_not_installed')
  return installedBindings
}
